import React from 'react';

import {
  Avatar,
  AverageStarRatingAndTotal,
  STAR_RATING_SECTION,
} from '../../../../shared';

import * as styles from './contact-details-sticky.style';
import { HERO_SECTION } from '../../../constants';
import { OverallStarRating } from '../../../../shared/recommendations/types';

export type Props = {
  avatarUrl: string;
  name: string;
  jobPosition?: string | null;
  agencyName?: string | null;
  isActive: boolean;
  overallStarRating?: OverallStarRating;
  onVendorTotalReviewsClick?: () => void;
};

const heroSection = HERO_SECTION.sticky;

const ContactDetailsPlatinumStickyReviews = ({
  avatarUrl,
  name,
  jobPosition,
  agencyName,
  isActive,
  overallStarRating,
  onVendorTotalReviewsClick,
}: Props): JSX.Element => {
  const avatarTitle = [name, jobPosition || 'Real Estate Agent']
    .filter(Boolean)
    .join(', ');

  return (
    <div
      css={styles.agentDetails({
        isActive,
      })}
      data-testid="agent-details"
    >
      <div
        css={styles.agentAvatarHolder}
        data-testid="trade-profile-hero__agent-avatar"
      >
        <Avatar
          size="custom"
          imageUrl={avatarUrl}
          imageTitle={avatarTitle}
          css={styles.agentAvatar}
        />
      </div>
      <div
        css={styles.detailsBody}
        data-testid="trade-profile-hero__details-body"
      >
        <p
          css={styles.name}
          data-testid={`trade-profile-hero-${heroSection}__name`}
        >
          {' '}
          {name}{' '}
        </p>
        {jobPosition && (
          <p
            css={styles.agentJob}
            data-testid={`trade-profile-hero-${heroSection}__agent-job-position`}
          >
            {jobPosition}{' '}
            {agencyName && (
              <span data-testid="trade-profile-hero__agent-agency">
                @ {agencyName}
              </span>
            )}
          </p>
        )}
        {overallStarRating && (
          <AverageStarRatingAndTotal
            section={STAR_RATING_SECTION.STICKY}
            averageRating={overallStarRating.rating}
            totalReviews={overallStarRating.totalReviews}
            scrollTo
            onVendorTotalReviewsClick={onVendorTotalReviewsClick}
          />
        )}
      </div>
    </div>
  );
};

export default ContactDetailsPlatinumStickyReviews;
